import React, { Component } from "react";
import { Label, Grid, Table, Button } from "semantic-ui-react";
import "../customerinfo/custinfo.css";
// import { genexceldownload } from "../../services/fileanddownloads";
import moment from "moment";
import MatFilter from "./matfiltermodal.js";
import "../../containers/Reports.css";
import jobsort from "../../services/jobsort";
import Roundy from "../../services/roundy";
import matpdfdownload from "../pdf/matReportPDFDownload";
class matCharge extends Component {
  constructor() {
    super();
    this.state = {
      selected: [],
      startdate: null,
      enddate: null,
      reportdata: null,
    };
  }

  gendatarows(mat_entries) {
    return mat_entries.map((temp_mat) => {
      return (
        <Table.Row>
          <Table.Cell>{temp_mat.workordernumber}</Table.Cell>
          <Table.Cell>
            {moment(temp_mat.datepurchased).format("MM/DD/YYYY")}
          </Table.Cell>
          <Table.Cell>
            $ {Roundy(temp_mat.amount * temp_mat.markuppercent)}
          </Table.Cell>
        </Table.Row>
      );
    });
  }

  genMaterials(vendors, grand_total) {
    return vendors.map((vendor, i, a) => {
      if (vendor.mat_entries.length) {
        let grand_total_row = (
          <Table.Row active>
            <Table.HeaderCell />
            <Table.HeaderCell>Grand Total : </Table.HeaderCell>
            <Table.HeaderCell>${Roundy(grand_total)}</Table.HeaderCell>
          </Table.Row>
        );
        // console.log("sub_total", sub_total);
        let sub_total_row = (
          <Table.Row active>
            <Table.HeaderCell />
            <Table.HeaderCell> Sub Total : </Table.HeaderCell>
            <Table.HeaderCell> $ {Roundy(vendor.sub_total)}</Table.HeaderCell>
          </Table.Row>
        );

        return (
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan="3">
                <Label color="red" id="matname" ribbon>
                  <h4>{vendor.companyname}</h4>
                </Label>
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.HeaderCell>WO #</Table.HeaderCell>
              <Table.HeaderCell>Date</Table.HeaderCell>
              <Table.HeaderCell>Amount</Table.HeaderCell>
            </Table.Row>
            {this.gendatarows(vendor.mat_entries)}
            {sub_total_row}
            {i === a.length - 1 ? grand_total_row : <div />}
          </Table.Body>
        );
      }
    });
  }
  render() {
    var filtered_vendors = this.props.vendors.filter(
      (m) =>
        this.state.selected.findIndex((s) => s.matnumber === m.matnumber) > -1
    );
    var grand_total = 0;
    let vendors = filtered_vendors.map((vendor) => {
      let mat_entries = jobsort.matentries(
        this.state.selected.filter((m) => m.matnumber === vendor.matnumber)
      );
      let sub_total = 0;
      mat_entries.map((m) => {
        sub_total += m.amount * m.markuppercent;
        grand_total += m.amount * m.markuppercent;
      });
      return { ...vendor, sub_total, mat_entries };
    });

    var report_table = (
      <Table>
        <Table.Row padded>
          <Table.HeaderCell colSpan="1">
            Material Charge Report
          </Table.HeaderCell>
          <Table.HeaderCell colSpan="1">
            <Button
              inverted
              color="blue"
              onClick={() => this.props.showFilterModal()}
            >
              Filter
            </Button>
          </Table.HeaderCell>
          <Table.HeaderCell colSpan="1">
            <Button
              inverted
              color="green"
              onClick={() => matpdfdownload(vendors, grand_total)}
            >
              Print
            </Button>
          </Table.HeaderCell>
        </Table.Row>
        {this.genMaterials(vendors, grand_total)}
      </Table>
    );
    return (
      <div>
        <Grid>
          <Grid.Column width={7}>
            <div className="matCharge">
              {this.props.vendors ? report_table : <div />}
            </div>
          </Grid.Column>
        </Grid>
        <MatFilter
          matcharges={this.props.matEntries}
          vendors={this.props.vendors}
          handleResults={(selected) =>{
            var firstDate = selected[0].datepurchased;
            selected.forEach(s => {
              if(s.datepurchased < firstDate){
                firstDate = s.datepurchased;
              }
            });
            console.log("First Date: ", firstDate);
            this.setState({ selected })}}
        />
      </div>
    );
  }
}

export default matCharge;



// WEBPACK FOOTER //
// ./src/components/reports/matCharge.js